import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate, useParams } from "react-router-dom";

const folders = [
  {
    name: "เอกสาร",
    type: "file",
    icon: <DescriptionIcon sx={{ fontSize: 70, color: "#1976d2" }} />,
  },
  {
    name: "รูปภาพ",
    type: "image",
    icon: <ImageIcon sx={{ fontSize: 70, color: "#2e7d32" }} />,
  },
];

const FarmerFolder = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // รับ id จาก route

  const openFolder = (type) => {
    navigate(`/customers/farmers/upload/${id}/${type}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
        โฟลเดอร์
      </Typography>

      <Grid container spacing={3}>
        {folders.map((folder, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 2,
                transition: "0.2s",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-3px)",
                },
              }}
            >
              <CardActionArea onClick={() => openFolder(folder.type)}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    py: 4,
                  }}
                >
                  {folder.icon}

                  <Typography sx={{ mt: 2, fontWeight: 600 }}>
                    {folder.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FarmerFolder;
